import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

export const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async event => {
    event.preventDefault();
    if (!email.trim() || !password) {
      setError('Enter your email or username and password.');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await fetch('/apilogin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), password })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.userId) {
        throw new Error(data.message || 'Unable to sign in. Please try again.');
      }
      dispatch({ type: 'LOG_IN', payload: data });
      sessionStorage.setItem('currentUser', JSON.stringify(data));
      navigate('/', { replace: true });
    } catch (loginError) {
      setError(loginError.message || 'Unable to sign in. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup">
      <img className="fusaLogoLogin" src="https://res.cloudinary.com/dof3z7iuh/image/upload/v1787773165/facilities-logo-1024x246_jkk6eb.webp" alt="Facilities USA" />
      <h1 className="loginTitle">Login</h1>
      <form className="signupInputsWrapper" onSubmit={handleLogin}>
        <label className="srOnly" htmlFor="login-email">Email or username</label>
        <input id="login-email" autoComplete="username" placeholder="Email or username..." className="inputAuth" value={email} onChange={event => setEmail(event.target.value)} />
        <label className="srOnly" htmlFor="login-password">Password</label>
        <input id="login-password" autoComplete="current-password" placeholder="Password..." type="password" className="inputAuth" value={password} onChange={event => setPassword(event.target.value)} />
        {error && <p className="loginError" role="alert">{error}</p>}
        <button type="submit" className="mainButton loginButton" disabled={loading}>{loading ? 'Signing in…' : 'Login'}</button>
      </form>
    </div>
  );
};
